<template>
  <div>
    <div class="white-section">
      <div class="d-flex mb-1 align-items-center">
        <div class="page-title users-page-title">
          <b-breadcrumb-item
            v-for="item in breadcrumb"
            :key="item.text"
            :active="item.active"
            class="bread-crumb"
          >
            <div v-if="item.active" class="mr-1">
              {{ item.translate ? $t(`navigation.${item.text}`) : item.text }}
            </div>
            <!-- {{$route.meta}} -->
            <!-- {{ item.text }} -->
          </b-breadcrumb-item>
        </div>
        <b-card-body style="padding: 0" class="search-box d-flex justify-content-end">
          <b-row>
            <!-- role input -->
            <b-col xl="6" lg="6" cols="12" sm="6" class="mb-md-0">
              <!-- <label>{{ $t("role.role") }}</label> -->
              <b-form-select v-model="roleFilter" class="w-100" @change="searchUser">
                <b-form-select-option value="all"> همه </b-form-select-option>
                <b-form-select-option v-for="r in roles" :key="r._id" :value="r._id">
                  <span>{{ $t(`role.${r.title}`) }}</span>
                </b-form-select-option>
              </b-form-select>
            </b-col>
            <!-- search input -->
            <b-col xl="6" lg="6" cols="12" sm="6" class="mb-md-0">
              <!-- <label class="mr-1">{{ $t("general.search") }}</label> -->
              <b-form-input
                @input="searchUser"
                v-model="searchTerm"
                :placeholder="$t('general.search')"
                type="text"
                class="d-inline-block"
              />
            </b-col>
          </b-row>
        </b-card-body>
        <router-link
          :disabled="
            !$ability.can('create', 'users') && !$ability.can('read', 'superuser')
          "
          tag="button"
          :to="{ name: 'addUser' }"
          class="btn btn-success btn-add"
          >{{ $t("general.add") }}
        </router-link>
      </div>
      <!-- table -->
      <div class="users-table user-table" v-if="!isLoading && users.length != 0">
        <vue-good-table
          v-if="users"
          :columns="columns"
          :rows="users"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
            mode: 'pages',
          }"
        >
          <template slot="table-column" slot-scope="props">
            <!-- <span v-if="props.column.field === 'Action'" class="text-nowrap">
              {{ $t("general.action") }}
            </span> -->
            <span v-if="props.column.field === 'NationalCode'" class="text-nowrap">
              {{ $t("user.nationalCode") }}
            </span>
            <span v-else>
              {{ $t(`user.${props.column.label}`) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->
            <span v-if="props.column.field === 'name'" class="text-nowrap">
              <span>{{ props.row.firstName }} {{ props.row.lastName }}</span>
            </span>
            <span v-if="props.column.field === 'NationalCode'" class="text-nowrap">
              <span > <span v-if="props.row.countryId && props.row.countryId.title.en === 'Iran'">{{ props.row.nationalCode }} / </span> <span v-if="props.row.countryId && props.row.countryId.title.fa">{{ props.row.countryId.title.fa }}</span></span>
            </span>
            <!-- Column: Roles -->
            <span v-if="props.column.field === 'roles'" class="text-nowrap">
              <template v-if="props.row.roles">
                <span v-for="(role, index) in props.row.roles" :key="'role_' + index">
                  <span v-if="role && role.title">
                    <span v-if=" role.title === 'doctor'">پزشک</span>
                    <span v-if=" role.title === 'employee'">کارمند</span>
                    <span v-if=" role.title === 'patient'">بیمار</span>
                    <span v-if=" role.title === 'developer'">توسعه دهنده</span>
                  </span>
                  <span v-else>{{ roles.find((item) => item._id === role).title }}</span>
                  <template v-if="index !== props.row.roles.length - 1">
                    -
                  </template></span
                >
              </template>
            </span>
            <!-- Column: Units -->
            <span v-else-if="props.column.field === 'units'" class="text-nowrap">
              <template v-if="props.row.units">
                <span v-for="(unit, index) in props.row.units" :key="'unit_' + index">
                  {{ unit.title }}
                  <template v-if="index !== props.row.units.length - 1">
                    -
                  </template></span
                >
              </template>
            </span>
            <!-- Column: Action -->
            <span v-else-if="props.column.field === 'Action'">
              <span>
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item
                    :disabled="
                      !$ability.can('update', 'users') &&
                      !$ability.can('read', 'superuser')
                    "
                    @click="editUser(props.row)"
                  >
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>{{ $t("general.edit") }}</span>
                  </b-dropdown-item>

                  <!-- <b-dropdown-item
                    :disabled="
                      !$ability.can('delete', 'users') &&
                      !$ability.can('read', 'superuser')
                    "
                    @click="removeUser(props.row)"
                  >
                    <feather-icon icon="TrashIcon" class="mr-50" />
                    <span>{{ $t("general.delete") }}</span>
                  </b-dropdown-item> -->
                  <b-dropdown-item
                    :disabled="
                      !$ability.can('addPermissions', 'users') &&
                      !$ability.can('read', 'superuser')
                    "
                    @click="assignPermission(props.row)"
                  >
                    <feather-icon icon="ShieldIcon" class="mr-50" />
                    <span>{{ $t("permissions.permissions") }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    :disabled="
                      !$ability.can('passwordChange', 'users') &&
                      !$ability.can('read', 'superuser')
                    "
                    @click="changePassword(props.row)"
                  >
                    <feather-icon icon="ShieldIcon" class="mr-50" />
                    <span>{{ $t("auth.changePassword") }}</span>
                  </b-dropdown-item>
                </b-dropdown>
                <b-form-checkbox
                  @change="switchStatus($event, props.row)"
                  switch
                  inline
                  :checked="props.row.status === 'active'"
                >
                  {{ $t(`general.${props.row.status}`) }}
                </b-form-checkbox>
              </span>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t("pagination.pageLength") }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['20', '50', '100']"
                  class="mx-1"
                  @change="handlePageChange"
                />
                <span class="text-nowrap">
                  <span class="text-nowrap">
                    {{ $t("general.of") }} {{ total }} {{ $t("general.pageText2") }}
                  </span>
                  <!-- {{ $t("pagination.pageText2") }} -->
                </span>
              </div>
              <div>
                <b-pagination
                  v-model="page"
                  :total-rows="total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @change="handlePageChange"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";
import filterRoles from "@/mixins/filterRoles";
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BAlert,
  BFormCheckbox,
  BCard,
  BCardHeader,
  BCardBody,
  BFormSelectOption,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import axios from "@/services/axios";

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormSelectOption,
    BButton,
  },
  data() {
    return {
      pageLength: 100,
      isLoading : false,
      page: 1,
      dir: false,
      doctorId: "",
      scrollTop: 0,
      columns: [
        {
          label: "name",
          field: "name",
        },
        {
          label: "username",
          field: "username",
        },
        {
          label: "fathersName",
          field: "fatherName",
        },
        {
          label: "nationalCode",
          field: "NationalCode",
        },
        {
          label: "mobile",
          field: "mobile",
        },
        {
          label: "roles",
          field: "roles",
        },
        {
          label: "units",
          field: "units",
        },
        {
          label: "action",
          field: "Action",
        },
      ],
      rows: [],
      searchTerm: "",
      ids: [],
      // roleFilter: "",
    };
  },
  // mounted() {
  //   this.filterRoles();
  // },
  methods: {
    // roleFiltered(val){
    // this.searchUser(this.searchTerm)
    // },
    // checkIfUserIsPatient(user) {
    //   if (
    //     user.roles.find((userToEditRole) => {
    //       return userToEditRole === this.filterRoles("patient");
    //     })
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    handlePageChange() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    async searchUser() {
      this.isLoading = true
      this.$store.commit("SET_IS_LOADING", true);
      let payload = {};
      this.searchTerm.length ? (payload.keyword = this.searchTerm) : "";
      if (this.roleFilter !== "all") {
        payload.roles = [this.roleFilter];
      } else {
        payload.roles = this.roles.map((role) => role._id);
        // console.log(payload.roles);
      }
      payload.page = this.page;
      payload.limit = parseInt(this.pageLength);
      this.$store.dispatch("user/searchUsers", payload).then((res) => {
        this.pageLength = payload.limit
        this.$store.commit("SET_IS_LOADING", false);
        this.$store.commit("user/SET_USERS", res);
        this.isLoading = false
      });
    },
    switchStatus(val, props) {
      val === true ? (props.status = "active") : (props.status = "inactive");

      let payload = {
        status: props.status,
      };
      this.$store
        .dispatch("user/switchUserStatus", {
          id: props._id,
          payload: payload,
        })
        .then(() => {
          this.$bvToast.toast(this.$t("toastification.editionSucceed"), {
            // title: this.$t('toastification.success'),
            variant: "success",
            solid: true,
          });
        })
        .catch((error) => {
          this.$bvToast.toast(this.$t("toastification.editionFailed"), {
            variant: "danger",
            solid: true,
          });
        });
    },
    removeUser(user) {
      // // console.log(user);
      // this.$store.commit("service/SET_SERVICE_TO_EDIT", user);
    },
    changePassword(user) {
      this.$store.commit("user/SET_USER_TO_EDIT", user);
      this.$router.push({
        name: "changeOtherUsersPassword",
        params: {
          id: user._id,
        },
      });
    },
    assignPermission(user) {
      this.$store.commit("user/SET_USER_TO_EDIT", user);
      this.$router.push({
        name: "assignPermission",
        params: {
          userId: user._id,
        },
      });
    },
    editUser(user) {
      // console.log(user);
      this.$store.commit("user/SET_USER_TO_EDIT", user);
      if (
        this.userToEdit.roles.find((userToEditRole) => {
          return userToEditRole === this.filterRoles("patient");
        })
      ) {
        this.$router.push({ name: "editUser", params: { id: user._id } });
      } else {
        this.$router.push({ name: "editUser", params: { id: user._id } });
        return userToEditRole === this.filterRoles("users");
      }
    },
  },
  computed: {
    breadcrumb() {
      return typeof this.$route.meta.breadCrumb === "function"
        ? this.$route.meta.breadCrumb(this.$route)
        : this.$route.meta.breadCrumb;
    },
    ...mapGetters({
      isRtl: "appConfig/isRTL",
      roles: "roles",
      units: "units/units",
      userToEdit: "user/userToEdit",
    }),
    total: {
      get() {
        return this.$store.getters["user/total"];
      },
    },
    // roleFilter: {
    //   set(role) {
    //     this.$store.commit("user/SET_ROLE_FILTER", role);
    //   },
    //   get() {
    //     return this.$store.getters["user/roleFilter"];
    //   },
    // },
    mobiles: {
      set(mobiles) {
        this.$store.commit("user/SET_MOBILES", mobiles);
      },
      get() {
        return this.$store.getters["user/mobiles"];
      },
    },
    statusVariant() {
      const statusColor = {
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
      };

      return (status) => statusColor[status];
    },
    users: {
      set(users) {
        this.$store.commit("user/SET_USERS", users);
      },
      get() {
        return this.$store.getters["user/users"];
      },
    },
  },
  directives: {
    Ripple,
  },
  mixins: [filterRoles],
  created() {
    this.setBreadcrumbs([
      { text: "homePage", translate: true, to: { name: "home" } },
      { text: "usersList", to: { name: "manageUsers" }, translate: true },
    ]);
    this.setCurrentBreadcrumb([
      { text: "usersList", to: { name: "usersList" }, translate: true },
    ]);
    this.doctorId = this.filterRoles("doctor");
    this.roleFilter = "all";
    this.searchUser();
  },
  watch: {
    roles() {
      this.searchUser();
    },
    page() {
      this.searchUser();
    },
    pageLength() {
      this.page=1
      this.searchUser();
    },
  },
};
</script>
